import React, { useState, useEffect } from 'react';
import { Formik, Form, ErrorMessage, } from 'formik';
import { uploadImageSchema } from './ValidationSchema';
import { uploadImages } from '../asiosConfig';
import { useNavigate } from 'react-router-dom';

import { Box } from "@mui/material";
import { Button, CircularProgress } from "@mui/material";



import CommonPopup from './CommonPopup';


const RegisterPhotoStep = ({ registrationData }) => {
  const navigate = useNavigate();
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [uploadResults, setUploadResults] = useState([]);



    const MAX_FILES = 10;
const MAX_FILE_SIZE_MB = 10;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;


  const [isSuccess, setIsSuccess] = useState(false);

//   useEffect(() => {
//   console.log("🔐 RegisterPhotoStep token:", localStorage.getItem("token"));
//   console.log("👤 user_id:", registrationData?.user_id || localStorage.getItem("user"));
// }, []);



const convertToJpeg = (file, maxSide = 1024) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      const img = new Image();
      img.src = reader.result;

      img.onload = () => {
        let { width, height } = img;

        if (width > maxSide || height > maxSide) {
          const ratio = Math.min(maxSide / width, maxSide / height);
          width = Math.round(width * ratio);
          height = Math.round(height * ratio);
        }

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (!blob) return reject("JPEG conversion failed");
            resolve(
              new File([blob], file.name.replace(/\.\w+$/, ".jpg"), {
                type: "image/jpeg",
                lastModified: Date.now(),
              })
            );
          },
          "image/jpeg",
          0.85
        );
      };

      img.onerror = reject;
    };
  });




const handleFileChange = (event, setFieldValue, setFieldTouched) => {
  const files = Array.from(event.target.files);

  // ❌ Max file count validation
  if (files.length > MAX_FILES) {
    setPopup({
      open: true,
      type: "error",
      message: `You can upload a maximum of ${MAX_FILES} photos.`,
    });
    event.target.value = "";
    return;
  }

  // ❌ Per-file size validation
  const oversizedFiles = files.filter(
    (file) => file.size > MAX_FILE_SIZE_BYTES
  );

  if (oversizedFiles.length > 0) {
    setPopup({
      open: true,
      type: "error",
      message: `Each photo must be less than ${MAX_FILE_SIZE_MB} MB.`,
    });
    event.target.value = "";
    return;
  }

 // ✅ Valid files
setSelectedFiles(files);

// 🔑 ALWAYS sync with Formik correctly
setFieldValue("photos", files, true);

// 🔑 clear previous error immediately
setFieldTouched("photos", false);


  if (setFieldTouched) {
    setFieldTouched("photos", true);
  }
};



  const initialValues = {
    photos: [],
    user_id: registrationData?.user_id || localStorage.getItem('user'),
    token: localStorage.getItem('token'), // Always use token from localStorage
  };

  const [popup, setPopup] = useState({
    open: false,
    type: "success", // success | error
    message: "",
  });
const handleSkip = () => {
  console.log("⏭️ Photo step skipped – no API call");

  // Clear registration flow state
  localStorage.removeItem("register_current_step");
  localStorage.removeItem("register_registration_data");
  localStorage.removeItem("last_complete_step");

  // Go directly to dashboard
  navigate("/my_matches", { replace: true });
};


const handleSubmit = async (values, { setSubmitting }) => {
  try {
    const { photos, user_id, token } = values;

    if (!photos || photos.length === 0) {
      setPopup({
        open: true,
        type: "error",
        message: "Please select at least one photo",
      });
      return;
    }

    let results = [];
    let successCount = 0;

//     for (let i = 0; i < photos.length; i++) {
//       const file = photos[i];

//       const formData = new FormData();
//       formData.append("photos", file);
//       formData.append("user_id", user_id);
//       formData.append("token", token);

//       console.log("📤 Uploading photo:", {
//   name: file.name,
//   size: file.size,
//   user_id,
// });


//       try {
//         const response = await uploadImages(formData);

//         if (response.status === 200 || response.status === 201) {
//           successCount++;
//           results.push({
//             name: file.name,
//             status: "success",
//           });
//         } else {
//           results.push({
//             name: file.name,
//             status: "error",
//             message: response.data?.message || "Upload failed",
//           });
//         }
//       } catch (err) {
//         results.push({
//           name: file.name,
//           status: "error",
//           message:
//             err.response?.data?.message ||
//             "This file is not supported or corrupted",
//         });
//       }

//       // small delay to avoid backend choke
//       await new Promise((res) => setTimeout(res, 400));
//     }

for (let i = 0; i < photos.length; i++) {
  try {
    const jpegFile = await convertToJpeg(photos[i]);

    const formData = new FormData();
    formData.append("photos[]", jpegFile);
    formData.append("user_id", user_id);
    formData.append("token", token);

    const response = await uploadImages(formData);

    if (response.status === 200 || response.status === 201) {
      successCount++;
      results.push({ name: jpegFile.name, status: "success" });
    } else {
      results.push({
        name: jpegFile.name,
        status: "error",
        message: response.data?.message || "Upload failed",
      });
    }
  } catch (err) {
    results.push({
      name: photos[i].name,
      status: "error",
      message: "Image conversion or upload failed",
    });
  }

  await new Promise(res => setTimeout(res, 400));
}


    setUploadResults(results);

    if (successCount > 0) {
      setPopup({
        open: true,
        type: "success",
        message:
          successCount === photos.length
            ? "All photos uploaded successfully"
            : "Some photos uploaded successfully.",
      });
    } else {
      setPopup({
        open: true,
        type: "error",
        message: "No photos could be uploaded. Please check the files.",
      });
    }
  } finally {
    setSubmitting(false);
  }
};




  const handlePopupClose = () => {
    setPopup({ ...popup, open: false });

    if (popup.type === "success") {
      // Clear registration data from localStorage
      localStorage.removeItem("register_current_step");
      localStorage.removeItem("register_registration_data");
      localStorage.removeItem("last_complete_step");

      navigate("/my_matches");
    }
  };


  return (
    <div
      sx={{
        flex: "1 1 500px",

        padding: {
      xs: "30px 40px",
      sm: "30px 40px",
      md: "30px 40px",
      lg: "30px 40px",
    },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* <Button
        onClick={handleSkip}
        style={{
          borderRadius: "50px",
          background: "linear-gradient(rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.22)), linear-gradient(90deg, #f78c25, #ff3c3c)",
          color: "#fff",
          fontWeight: 600,
          fontSize: "16px",
          height: "49px",
          textTransform: "none",
          fontFamily: "Montserrat",
          boxShadow: "0 4px 8px rgba(255,60,60,0.3)",
          marginBottom: "20px",
        }}
      >
        SKIP
      </Button> */}

      <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
  <Button
    onClick={handleSkip}
    sx={{
      borderRadius: "40px",
      px: {
        xs: "40px",
        sm: "45px",
        md: "45px",
      },
      background:
        "linear-gradient(rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.22)), linear-gradient(90deg, #f78c25, #ff3c3c)",
      color: "#fff",
      fontWeight: 600,
      fontSize: "14px",
      height: "40px",
      textTransform: "none",
      fontFamily: "Montserrat",
      boxShadow: "0 4px 8px rgba(255,60,60,0.3)",
      mb: "20px",
    }}
  >
    SKIP
  </Button>
</Box>


      <Formik
        initialValues={initialValues}
        validationSchema={uploadImageSchema}
         validateOnChange={false}
  validateOnBlur={false}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, setFieldValue , setFieldTouched}) => (
          <Form
            style={{
              width: "100%",
              maxWidth: "480px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              textAlign: "left",
              fontFamily: "Montserrat",
            }}
          >
            <div>
              <input
                type="file"
                multiple
                accept=".jpg, .jpeg, .png, .webp"
                onChange={(e) => handleFileChange(e, setFieldValue, setFieldTouched)}
                style={{
                  borderRadius: "10px",
                  backgroundColor: "#f5fcfe",
                  border: "1px solid #d4d4d4",
                  height: "60px",
                  display: "flex",
                  alignItems: "center",
                  padding: "15px",
                  fontFamily: "Montserrat",
                  width: "100%",
                }}
              />
              <ErrorMessage name="photos" component="div" style={{ color: 'red', fontSize: '12px', marginBottom: '2px' }} />
            </div>

            {selectedFiles.length > 0 && (
              <div style={{ marginTop: "10px" }}>
                <h4>Selected Files:</h4>
                <ul>
                  {selectedFiles.map((file, index) => (
                    <li key={index}>{file.name}</li>
                  ))}
                </ul>
              </div>
            )}



            {/* <Button
              type="submit"
              variant="contained"
              disabled={isSubmitting}
              style={{
                borderRadius: "50px",
                background: "linear-gradient(rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.22)), linear-gradient(90deg, #f78c25, #ff3c3c)",
                color: "#fff",
                fontWeight: 600,
                fontSize: "16px",
                height: "49px",
                textTransform: "none",
                fontFamily: "Montserrat",
                boxShadow: "0 4px 8px rgba(255,60,60,0.3)",
              }}
            >
              {isSubmitting ? "Uploading..." : "Upload & Finish"}
            </Button> */}

            <Button
  type="submit"
  variant="contained"
  disabled={isSubmitting}
  sx={{
    borderRadius: "50px",
    background:
      "linear-gradient(rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.22)), linear-gradient(90deg, #f78c25, #ff3c3c)",
    color: "#fff",
    fontWeight: 600,
    fontSize: "16px",
    height: "49px",
    textTransform: "none",
    fontFamily: "Montserrat",
    boxShadow: "0 4px 8px rgba(255,60,60,0.3)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
  }}
>
  {isSubmitting && (
    <CircularProgress
      size={20}
      thickness={5}
      sx={{ color: "#fff" }}
    />
  )}

  {isSubmitting ? "Uploading..." : "Upload & Finish"}
</Button>

          </Form>
        )}
      </Formik>
      {/* <Popup open={popupOpen} onClose={handlePopupClose} message={popupMessage} /> */}

      <CommonPopup
        open={popup.open}
        type={popup.type}
        message={popup.message}
        onClose={handlePopupClose}
      />

    </div>
  );
};

export default RegisterPhotoStep;
